<script lang="ts">
    import { browserState } from '@/shared/state/browser.svelte';
    import { componentTooltip } from '@/shared/utils/tooltips';
    import type { ManualDataReputationSet } from '@/types/data/manual';

    import TableSortedBy from '@/components/common/TableSortedBy.svelte';
    import Tooltip from '@/components/tooltips/reputation-header/TooltipReputationHeader.svelte';
    import WowthingImage from '@/shared/components/images/WowthingImage.svelte';

    type Props = {
        reputation: ManualDataReputationSet;
        slug: string;
    };
    let { reputation, slug }: Props = $props();

    let repIds: number[] = $derived([
        reputation.both?.id ?? 0,
        reputation.alliance?.id ?? 0,
        reputation.horde?.id ?? 0,
    ]);
    let sortingBy = $derived(
        (browserState.current.reputations.sortOrder[slug] || []).some(
            (repId) => repId > 0 && repIds.indexOf(repId) >= 0
        )
    );

    let onClick: (event: Event) => void = $derived(() => {
        browserState.current.reputations.sortOrder[slug] = sortingBy ? [] : repIds;
    });
</script>

<style lang="scss">
    th {
        --width: 3.8rem;

        border: 1px solid var(--border-color);
        border-right-width: 0;
        border-top-width: 0;
        padding: 0.3rem 0;
        position: relative;
    }
    .faction0,
    .faction1 {
        --image-border-width: 2px;
    }
</style>

<th
    data-reputation-ids={repIds.filter((id) => id > 0).join(',')}
    onclick={onClick}
    use:componentTooltip={{
        component: Tooltip,
        props: { reputation },
    }}
>
    {#if reputation.both}
        <div class="split-icon-no">
            <WowthingImage name={reputation.both.icon} size={40} border={2} />
        </div>
    {:else if reputation.alliance && reputation.horde}
        <div class="split-icon-yes">
            <WowthingImage name={reputation.alliance.icon} size={40} border={2} />
            <WowthingImage name={reputation.horde.icon} size={40} border={2} />
        </div>
    {:else if reputation.alliance}
        <div class="faction0">
            <WowthingImage name={reputation.alliance.icon} size={40} border={2} />
        </div>
    {:else if reputation.horde}
        <div class="faction1">
            <WowthingImage name={reputation.horde.icon} size={40} border={2} />
        </div>
    {/if}

    {#if sortingBy}
        <TableSortedBy />
    {/if}
</th>
